import {NameWithAvatar} from '@common/datatable/column-templates/name-with-avatar';
import React, { useMemo, useEffect } from 'react';
import { Track } from '@player/types';
import clsx from 'clsx';
import {useTrackTableMeta} from '@app/web-player/tracks/track-table/use-track-table-meta';
import {getTrackImageSrc} from '@app/web-player/tracks/track-image/track-image';

import { ArtistLinks } from '@app/web-player/artists/artist-links'
import { useIsTrackPlaying } from '@app/web-player/tracks/hooks/use-is-track-playing';

interface TrackNameColumnProps {
    track: Track;
}
export function TrackNameColumn({track}: TrackNameColumnProps) {
    const { hideTrackImage, queueGroupId } = useTrackTableMeta()
    const isPlaying = useIsTrackPlaying(track.id, queueGroupId)

    const src = useMemo(() => {
        const image = getTrackImageSrc(track)

        if (!image) return '';

        if (image?.includes('scdn')) {
            return image
        }

        if (!image?.endsWith('.webp')) {
            return image
        }

        // Split the URL to get the path and filename
        const lastSlashIndex = image.lastIndexOf('/');
        const basePath = image.substring(0, lastSlashIndex + 1);
        const filename = image.substring(lastSlashIndex + 1);

        // Add thumbnail prefix to filename
        return `${basePath}thumbnail-${filename}`;
    }, [track])

    return (
        <NameWithAvatar
            image={!hideTrackImage ? src : undefined}
            label={track.name}
            avatarSize="w-40 h-40 md:w-60 md:h-60 border"
            description={
                <ArtistLinks artists={track.artists} />
            }
            labelClassName={clsx(
                isPlaying && 'text-primary',
                'max-md:text-[15px] max-md:leading-6',
                {
                    'text-muted/50': !isPlaying && track.activity?.viewed
                }
            )}
        />
    );
}
